import type {ReactElement} from 'react';
import React from 'react';
import type {ContextualMenuDropdownOptionProps} from '@Components/contextual-menu/components/contextual-menu-dropdown-option';
import {ContextualMenuDropdownOption} from '@Components/contextual-menu/components/contextual-menu-dropdown-option';

const SIDEPANEL_POPUPS_WIDTH = 254;
const SIDEPANEL_POPUPS_MAX_HEIGHT = 360;

export function PosterEditingBaseDropdownOption({...props}: ContextualMenuDropdownOptionProps): ReactElement<any> {
  return <ContextualMenuDropdownOption popupMaxHeight={SIDEPANEL_POPUPS_MAX_HEIGHT} popupWidth={SIDEPANEL_POPUPS_WIDTH} {...props} />;
}
